module.exports = __webpack_public_path__ + "static/media/Elem.6aec7ce3.webp";